// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__3sRC_","unreadBadge":"styles_unreadBadge__3H6kp","modalContent":"styles_modalContent__2ysy8","modal":"styles_modal__2fXnV"};